(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name VideoconsultaService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('VideoconsultaService', VideoconsultaService);

    VideoconsultaService.$inject = ["$http","$q","$window","$location"];

    function VideoconsultaService($http,$q,$window,$location){  
       //console.log("app.aut Servicio ENABLE");

        var video = {
            getPacientes:getPacientes,
            SavePaciente:SavePaciente,
            SaveCaso:SaveCaso,
            getHorasdisponibles:getHorasdisponibles,
            getConsultas:getConsultas,
            getVideoConsultas:getVideoConsultas,
            getEstados:getEstados,
            getMeses:getMeses,
            videconsultaId:videconsultaId,
            editVideoconsulta:editVideoconsulta,
            getProductos:getProductos,
            getAlertas:getAlertas

        };

        function getPacientes(pagina){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            return $http.get('/ajax/getpacientes', { params : { "pagina":pagina, lang_id:lang_id } }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };
        
        function SavePaciente(vm){
            var config = {
                headers : {
                   // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            
            return $http.post('/ajax/paciente', {
                nombre:vm.nombre,
                razas:vm.razas,
                sexo:vm.sexo,
                peso:vm.peso,
                edad:vm.edad,
                especie:vm.especie,
                castrado:vm.castrado
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

         function SaveCaso(vm){
            var config = {
                headers : {
                }
            }
            
            return $http.post('/ajax/casoclinico', {
                caso_clinico:vm.videoconsulta.caso_clinico,
                id:vm.videoconsulta.id,
                paciente_id:vm.videoconsulta.paciente_id,
                file_id:vm.videoconsulta.ficheros,
                timesFinal:JSON.stringify(vm.timesFinal)
              
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getHorasdisponibles(fecha){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            return $http.get('/ajax/horasdisponibles', { params : { "fecha":fecha, lang_id:lang_id } }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

         function getConsultas(paciente_id){

            var config = {
                headers : {}
            }

            return $http.get('/ajax/resumenconsultas', {
                params : {
                    paciente_id:paciente_id
                }
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };
        
        function getVideoConsultas(vm){

           var config = {
                headers : {
                }
            }

            return $http.get('/ajax/historialconsultas', {
                params : { 
                    filtros:JSON.stringify(vm.filtros)
                }
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getEstados(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/estadoconsultas', {   
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getMeses(vm)
        {
            console.log(vm);
            var config = {headers : {}}

            return $http.get('/ajax/meses', { 
                params : { currentDay:vm.currentDay}
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function videconsultaId(videoconsulta_id){

            var config = {
                headers : {}
            }

            return $http.get('/ajax/videconsultaseleccionada', { 
                params : { 
                    videoconsulta_id:videoconsulta_id
                } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getAlertas(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/alertas', {   
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function editVideoconsulta(vm){
            var config = {
                headers : {
                   // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            

            return $http.post('/ajax/editarvideoconsulta', {
                    videoconsulta:JSON.stringify(vm.videoconsulta),
                    timesFinal:JSON.stringify(vm.timesFinal),
                    ficheros:JSON.stringify(vm.ficheros),
                    //ficheros:vm.ficheros
             }, config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function getProductos(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/getproductos', { params:{
            servicio_id:vm.servicio_id  }
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };


        return video;
    }

})();

